<template>
  <div>
    <div class="title-lable-error">
      <span class="ml-3">Request already exists</span>
    </div>
    <div
      class="d-flex flex-row mt-3 ml-3"
      style="color: #757575; font-size: 0.85rem"
    >
      <div>
        A similar request has been submitted and has not been processed. Please
        edit the request and send it back to us.
      </div>
    </div>
  </div>
</template>

<script>
import base from "@/scripts/base";

export default {
  extends: base,
};
</script>